import Tags from './tags'
import Uploads from './uploads'
import Accounts from './accounts'
import { BadDataReviewSubmissions } from './review-bad-data/BadDataReviewSubmissions'
import { FacebookConnectionsPage } from './facebook-connections'

export default {
  Tags,
  Uploads,
  Accounts,
  ReviewBadData: BadDataReviewSubmissions,
  FacebookConnections: FacebookConnectionsPage,
}
